var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dilu-page"},[_vm._v(" [物联网卡列表] 开发中... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }